import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const SOLVENCY_FORM_NAMES = {
  SOLVENCY_VARIANTS: 'solvencyVariants',
  SOLVENCY_TABLE: 'solvencyTable',
  ANTICIPATED_OUTCOME: 'anticipatedOutcome',
} as const;

export const solvencyVariants = [
  'Debt to equity ratio',
  'Total assets to equity ratio',
  'Total assets to total liabilities ratio',
  'Capitalization ratio',
  'Interest coverage ratio',
];

//  ---- COMMON ----

export interface ISolvencyFormValuesType {
  [SOLVENCY_FORM_NAMES.SOLVENCY_VARIANTS]: string[];
  [SOLVENCY_FORM_NAMES.SOLVENCY_TABLE]: IPeriodsTableRow[];
  [SOLVENCY_FORM_NAMES.ANTICIPATED_OUTCOME]: string;
}

export const solvencyInitialValues = {
  [SOLVENCY_FORM_NAMES.SOLVENCY_VARIANTS]: solvencyVariants,
  [SOLVENCY_FORM_NAMES.SOLVENCY_TABLE]: getFormTableInitialValues2(solvencyVariants.length, initialPeriodsTableRow),
  [SOLVENCY_FORM_NAMES.ANTICIPATED_OUTCOME]: '',
};
